const PREFIX = "debug-december:";

const setItem = (key: string, value: string) => {
  window.localStorage.setItem(`${PREFIX}${key}`, value);
};

const getItem = (key: string) => {
  return window.localStorage.getItem(`${PREFIX}${key}`);
};

const popItem = (key: string) => {
  const value = getItem(key);
  window.localStorage.removeItem(`${PREFIX}${key}`);
  return value;
};

export const setAuthToken = (token: string) => {
  setItem("token", token);
};

export const removeAuthToken = () => {
  popItem("token");
};

export const getAuthToken = () => {
  return getItem("token");
};

export const tokenExists = () => {
  return !!getAuthToken();
};

export const saveCodeToLocalStorage = (
  year: number,
  day: number,
  userId: number,
  code: string,
) => {
  setItem(`code-${year}-${day}-${userId}`, code);
};

export const getCodeFromLocalStorage = (
  year: number,
  day: number,
  userId: number,
) => {
  const userCode = getItem(`code-${year}-${day}-${userId}`);
  if (userCode) {
    return userCode;
  }
  return getItem(`code-${year}-${day}-0`);
};

export const removeCodeFromLocalStorage = (
  year: number,
  day: number,
  userId: number,
) => {
  popItem(`code-${year}-${day}-${userId}`);
};

export const saveReferrerToLocalStorage = (referrer: string) => {
  setItem("referrer", referrer);
};

export const popReferrerFromLocalStorage = () => {
  return popItem("referrer");
};

export const getHasUserSeenIntro = () => {
  return getItem("has-seen-intro") === "true";
};

export const setHasUserSeenIntro = () => {
  setItem("has-seen-intro", "true");
};

export const setPrizeReminderShown = () => {
  setItem("2024-prize-reminder-shown", "true");
};

export const getPrizeReminderShown = () => {
  return getItem("2024-prize-reminder-shown") === "true";
};
